<ng-container [ngSwitch]="displayType">
  <ng-template [ngSwitchCase]="'markerRow-fieldColum'">
    <ion-row class="ion-nowrap c-border-bottom">
      <ion-col size="4" class="c-border-right"></ion-col>
      <ion-col size="4" *ngFor="let fieldOrLabel of champs; let last=last" class="ion-text-center"  [ngClass]="{'c-border-right': !last}">
        {{ fieldOrLabel.label }}
      </ion-col>
    </ion-row>
    <ng-container *ngFor="let group of formDynamiqueFormArray.controls; let index=index">
      <ng-container *ngIf="group | asFormGroupPipe as formGroup">
        <app-c-form-dynamique
          [formGroup]="formGroup"
          [formSketchFormDynamique]="formSketchFormDynamique"
          [modeShow]="modeShow"
          [etatId]="etatId"
          [forms]="formGroup"
          [blocName]="blocName"
          [step]="step"
          [bloc]="bloc"
          [display]="display"
          [observeSourcesArr]="observeSourcesArr"
          [context]="context"
          [displayType]="displayType"
          [index]="index"
          [sourceMarqueurs]="(sourceMarqueurs | sourceMarqueursIntoLegend:fixedLegend)"
          [canEditDescription]="index >= fixedLegend.length && !modeShow"
          (modifiedDescription)="modifiedDescription.emit($event)"
        ></app-c-form-dynamique>
      </ng-container>
    </ng-container>
  </ng-template>
  <!-- <ng-template [ngSwitchCase]="'markerColumn-fieldRow'">
    <ion-row>
      <ng-container *ngFor="let group of formDynamiqueFormArray.controls">
        <ng-container *ngIf="group | asFormGroupPipe as formGroup">
          <ion-col size="4">
            <app-c-form-dynamique
            [formGroup]="formGroup"
            [formSketchFormDynamique]="formSketchFormDynamique"
            [modeShow]="modeShow"
            [forms]="formGroup"
            [blocName]="blocName"
            [step]="step"
            [bloc]="bloc"
            [display]="display"
            [observeSourcesArr]="observeSourcesArr"
            [context]="context"
            [displayType]="displayType"
            ></app-c-form-dynamique>
          </ion-col>
        </ng-container>
      </ng-container>
    </ion-row>
  </ng-template> -->
</ng-container>
